import React from 'react';

const Footer = () =>{
    return (
        <footer id="footers" className="footers">
        <div className="copyrights text-center">
          &copy; Copyright <strong><span>QuestionHub Ghana</span></strong>. All Rights Reserved
        </div>
       
      </footer>
    
    )
}

export default Footer;